// const host = "https://f327644f14ae.ngrok-free.app";
// const host = "https://be-loyalty.soc2cert.com";
//const host = "http://localhost:3500";
//const host = process.env.REACT_APP_API_URL;
const host = "https://city-center-testing.focusteck.com";
/////////AUTHENTICATION//////////////////////
export const signUpRoute = `${host}/invites/verify-code`;
export const resendInvitationRoute = `${host}/invites/resend-invite/`;
export const meRoute = `${host}/auth/who-am-i`;
export const verifyAndUpdateRoute = `${host}/invites/accept-invite`;
export const loginRoute = `${host}/auth/login`;
export const forgetPasswordRoute = `${host}/auth/forget-password/`;
export const verifyOTPRoute = `${host}/auth/verify-forget-password-otp/`;
export const changeForgetPasswordRoute = `${host}/auth/change-forget-password/`;
export const resendOTPRoute = `${host}/auth/resend-otp/`;
/////////USERSROLES//////////////////////////
export const creatUserRoute = `${host}/users/create-user`;
export const createMemberRoute = `${host}/users/create-member`;
export const updateProfileRoute = `${host}/users/update/`;
export const updateDeviceIdRoute = `${host}/users/update-device-ids/`;
export const updatePasswordRoute = `${host}/users/update-password/`;
export const editUserRoute = `${host}/users/update-user/`;
export const deactivateUserRoute = `${host}/users/deactivate/`;
export const deleteUserRoute = `${host}/users/archive/`;
export const getAllUsersRoute = `${host}/users/`;
export const getAllRolesRoute = `${host}/roles/`;
export const getAllGroupsRoute = `${host}/groups/`;
export const updateGroupRoute = `${host}/groups/update/`;
export const createGroupsRoute = `${host}/groups/create/`;
export const deleteGroupRoute = `${host}/groups/archive/`;
export const createRoleRoute = `${host}/roles/create`;
export const updateRoleRoute = `${host}/roles/update/`;
export const updateDeletedRoleRoute = `${host}/roles/update-deleted/`;
export const deleteRoleRoute = `${host}/roles/archive/`;
export const getNotMemberUsers = `${host}/users/get-not-memeber-users`;
export const getVendorMemberUsers = `${host}/users/get-vendor-members`;
export const createBulkUsersRoute = `${host}/users/create-bulk-users`;
export const getAllAssociatedVendorsRoute = `${host}/users/get-vendors`;
////////DASHBOARD//////////////////////////////
export const memberCountRoute = `${host}/dashboard/members-count-stats`;
export const vendorCountRoute = `${host}/dashboard/vendors-count-stats`;
export const offerCountRoute = `${host}/dashboard/offers-count-stats`;
export const eventCountRoute = `${host}/dashboard/events-count-stats`;
export const offerQuarterlyRoute = `${host}/dashboard/offers-quarterly-stats`;
export const offerAvailedRoute = `${host}/dashboard/transaction-count-stats`;
export const availedWeeklyRoute = `${host}/dashboard/transaction-weekly-stats`;
export const availedMonthlyRoute = `${host}/dashboard/transaction-monthly-stats`;
export const transactionMonthlyStatsByRangeRoute = `${host}/dashboard/transaction-monthly-stats-by-range`;
export const offerAvailedTypeRoute = `${host}/dashboard/offers-type-stats`;
export const availedOffersProjectsRoute = `${host}/dashboard/most-availed-offers-stats`;
export const customerSegmentationRoute = `${host}/dashboard/customer-segmentation`;
export const topAvailedCitiesRoute = `${host}/dashboard/city-transaction-stats`;
export const revenueGrowthRoute = `${host}/dashboard/revenue-growth`;
export const averageTransactionValueRoute = `${host}/dashboard/average-transaction-value`;
////////REPORTING//////////////////////////////
export const reportingMembersRoute = `${host}/reporting/members-report`;
export const transactionsRoute = `${host}/reporting/transactions-report`;
export const reportingOffersRoute = `${host}/reporting/offers-report`;
////////AWS////////////////////////////////////
export const profilePutSignedURLRoute = `${host}/files/get-signed-url`;
export const profileGetSignedURLRoute = `${host}/files/get-preview-signed-url`;
export const getSignedURLWithVariantRoute = `${host}/files/get-preview-signed-url-variant`;
export const getMultiSignedURLRoute = `${host}/files/get-multiple-preview-signed-urls`;
export const getMultipleVariantSignedURLRoute = `${host}/files/get-multivariant-preview-signed-urls`;
///////PROJECTS///////////////////////////////
export const getAllTagsRoute = `${host}/tags`;
export const createTagRoute = `${host}/tags/create`;
export const createProjectsRoute = `${host}/projects/create`;
export const deleteProjectRoute = `${host}/projects/`;
export const getProjectRoute = `${host}/projects/`;
export const getAllProjectsRoute = `${host}/projects/filtered/`;
export const getAllUnfilteredProjectsRoute = `${host}/projects/`;
export const getProjectManagerUsersRoute = `${host}/users/get-project-manager-users`;
///////LOYALTYMEMBERS/////////////////////////
export const getAllMemberGroups = `${host}/member-groups/`;
export const getAllTiers = `${host}/member-groups/tier-names`;
export const getAllPrintingJobs = `${host}/cards-printing`;
export const createPrintingJob = `${host}/loyalty-cards/print-cards`;
export const createMemberGroup = `${host}/member-groups/create`;
export const patchMemberGroup = `${host}/member-groups/`;
export const deleteMemberGroup = `${host}/member-groups/`;
export const projectMembersRoute = `${host}/members/in-project/`;
export const notProjectMembersRoute = `${host}/members/not-in-project/`;
export const createCardTemplateRoute = `${host}/card-templates/create-card-template/`;
export const getCardTemplatesRoute = `${host}/card-templates/`;
export const updateProjectMembersRoute = `${host}/projects/add-remove-project-members/`;
export const updateTierMembersRoute = `${host}/member-groups/add-remove-members/`;
export const tierMembersRoute = `${host}/members/in-group/`;
export const notTierMembersRoute = `${host}/members/not-in-group/`;
export const getLoyaltyCardsRoute = `${host}/loyalty-cards/`;
export const deleteTemplateRoute = `${getLoyaltyCardsRoute}archive-card-template/`;
export const updateBulkCardsRoute = `${host}/loyalty-cards/update-templates`;
export const getMembersRoute = `${host}/members/`;
export const bulkUpdateTiersRoute = `${host}/member-groups/bulk-update`;
export const getBulkTierDataRoute = `${host}/member-groups/get-bulk-data`;
export const getBulkUpdateTiersRoute = `${host}/member-groups/get-bulk-data`;
export const getMemberChildsRoute = `${host}/members/get-member-childs/`;
/////////OFFERS/////////////////////////////////
export const getAllOffersRoute = `${host}/offers/filtered/`;
export const getAllOffersUnfilteredRoute = `${host}/offers/`;
export const getAllActiveUpcomingOffersRoute = `${host}/offers/all-active-upcoming`;
export const createOfferRoute = `${host}/offers/create-offer`;
export const projectVendorsRoute = `${host}/vendors`;
export const getFeaturedOffersRoute = `${host}/offers/all-featured-priority`;
export const markFeaturedOffersRoute = `${host}/offers/mark-featured`;
export const unMarkFeaturedOffersRoute = `${host}/offers/unmark-featured`;
////////CATEGORIES/////////////////////////////
export const getAllCategoriesRoute = `${host}/categories/`;
///////VENDORS/////////////////////////////////
export const createVendorRoute = `${host}/vendors/`;
export const createVendorMemberRoute = `${host}/vendors/create-vendor-member`;
export const getAllVendorsRoute = `${host}/vendors/filtered/`;
export const getAllVendorsUnfilteredRoute = `${host}/vendors/`;
export const getBulkVendorsRoute = `${host}/vendors/only-vendors-data`;
export const vendorBulkUpdateRoute = `${host}/vendors/bulk-update`;
export const getVendorManagersRoute = `${host}/users/get-vendor-managers`;
export const getVendorManagerUsersRoute = `${host}/users/get-vendor-manager-users`;
export const getFeaturedVendorsRoute = `${host}/vendors/all-featured-priority`;
export const markFeaturedVendorsRoute = `${host}/vendors/mark-featured`;
export const unMarkFeaturedVendorsRoute = `${host}/vendors/unmark-featured`;
/////CAMPAIGNS/////////////////////////////////
export const getAllCampaignsRoute = `${host}/campaigns/`;
export const deleteCampaignRoute = `${host}/campaigns/archive`;
export const createCampaignRoute = `${host}/campaigns/create-campaign`;
/////EVENTS/////////////////////////////////////
export const getAllEventsRoute = `${host}/events/`;
export const getAllActiveUpcomingEventsRoute = `${host}/events/all-active`;
export const deleteEventRoute = `${host}/events/archive`;
export const createEventRoute = `${host}/events/create-event`;
export const getEventVenuesRoute = `${host}/event-venues`;
export const getFeaturedEventsRoute = `${host}/events/all-featured-priority`;
export const markFeaturedEventsRoute = `${host}/events/mark-featured`;
export const unMarkFeaturedEventsRoute = `${host}/events/unmark-featured`;
//////NOTIFICATIONS////////////////////////////
export const sendNotificationRoute = `${host}/notifications/`;
export const readNotificationRoute = `${host}/notifications/read-notifications`;
export const readOneNotificationRoute = `${host}/notifications/read-single-notification`;
export const emailNotificationRoute = `${host}/notifications/email-notifications`;
///////SETTINGS////////////
export const getCacRoute = `${host}/settings`;
export const getClientSettingsRoute = `${host}/client-settings`;
export const updateFreePlanRoute = `${host}/client-settings/free-plan`;
export const updateCacRoute = `${host}/settings`;
export const logoutRoute = `${host}/users/logout`;
///////MODERATIONS////////////
export const projectModerationsRoute = `${host}/projects/moderations`;
export const approveRejectModerationRoute = `${host}/moderations`;
export const vendorModerationsRoute = `${host}/vendors/moderations`;
export const offerModerationsRoute = `${host}/offers/moderations`;
export const eventModerationsRoute = `${host}/events/moderations`;
export const projectModerationHistoryRoute = `${host}/projects/moderation-history`;
export const vendorModerationHistoryRoute = `${host}/vendors/moderation-history`;
export const offerModerationHistoryRoute = `${host}/offers/moderation-history`;
export const eventModerationHistoryRoute = `${host}/events/moderation-history`;
export const getModerators = `${host}/users/moderators`;
export const getModeratorCount = `${host}/users/moderatorCount`;
///////CLIENTS////////////
export const getClientsRoute = `${host}/users/clients-active`;
export const getAllClientsRoute = `${host}/users/clients`;
export const inviteClientRoute = `${host}/users/create-client`;
export const deleteClientRoute = `${host}/users/archive-client/`;
export const editClientRoute = `${host}/users/update-client/`;
///////SUBSCRIPTIONS///////
export const checkoutSessionRoute = `${host}/subscription/session/`;
export const getSubscriptionRoute = `${host}/subscription/data/`;
export const calculateNewRateRoute = `${host}/subscription/calculate`;
export const applyNewRateRoute = `${host}/subscription/apply-new-rate`;
export const cancelSubscriptionRoute = `${host}/subscription/cancel`;
export const getModulesRoute = `${host}/modules/`;
///////PLANS///////////////////
export const getAllPlans = `${host}/plans/all-active-plans`;
export const getPlans = `${host}/plans/all-plans`;
export const createPlanRoute = `${host}/plans/create`;
export const editPlanRoute = `${host}/plans/edit/`;
///////PAYMENTS////////////////////
export const getAllPayments = `${host}/payment-history/`;

///////CMS/BANNERS/////////////////////
export const createBannerRoute = `${host}/banners/create-banner`;
export const getBannersRoute = `${host}/banners/get-banners`;
export const updateBannerRoute = `${host}/banners/update-banner/`;
export const deleteBannerRoute = `${host}/banners/delete-banner/`;

///////CMS/CINEMAS/////////////////////
export const getCinemasRoute = `${host}/cinemas/get-cinemas`;
export const createCinemaRoute = `${host}/cinemas/create-cinema`;
export const updateCinemaRoute = `${host}/cinemas/update-cinema/`;
export const deleteCinemaRoute = `${host}/cinemas/delete-cinema/`;
